import { Person, Lock, Tune } from '@mui/icons-material'

export const ACCOUNT_NAVIGATION = [
  {
    section: 'Algemeen',
    items: [
      {
        label: 'Profiel',
        value: 'profiel',
        hash: '#profiel',
        icon: Person,
      },
    ],
  },
  {
    section: 'Beveiliging',
    items: [
      {
        label: 'Wachtwoord wijzigen',
        value: 'wachtwoord',
        hash: '#wachtwoord',
        icon: Lock,
      },
    ],
  },
  {
    section: 'Voorkeuren',
    items: [
      {
        label: 'App-voorkeuren',
        value: 'voorkeuren',
        hash: '#voorkeuren',
        icon: Tune,
      },
    ],
  },
]
